import { useContext, useState } from "react";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { useForm } from "react-hook-form";
import { getSimReplacementRoute } from "@api-routes";
import { IUserDetailsInfo } from "../../Profile/interface/IUserDetails";
import { ISimCardChangeInfo, IUserAddress } from "@common/eircode/Interface/IAddressForm";
import { useFetch } from "@common/hook/useFetch";

export const useReplacementSimForm = (deliveryAddress?: IUserAddress, userDetails?: IUserDetailsInfo) => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [postReplacementSimState, { post }] = useFetch();
    const [barPreviousSim, setBarPreviousSim] = useState(false);

    const formMethods = useForm<ISimCardChangeInfo>({
        defaultValues: {
            billingAddress: deliveryAddress?.billingAddress,
            canEdit: deliveryAddress?.canEdit,
            mobileNumber: "",
        },
    });

    const postReplacementSim = () => {
        if (selectedService) {
            return post<boolean>(
                getSimReplacementRoute(selectedService.id, barPreviousSim, formMethods.getValues("mobileNumber"))
            );
        }

        return undefined;
    };

    const postReplacementSimInitial = (openErrorModal: () => void, onFormSubmitted: () => void) => {
        const postReplacementSimResult = postReplacementSim();

        if (postReplacementSimResult) {
            postReplacementSimResult
                .then((isSubmitted) => {
                    if (isSubmitted) {
                        onFormSubmitted();
                    } else {
                        openErrorModal();
                    }
                })
                .catch(() => {
                    openErrorModal();
                });
        }
    };

    const postReplacementSimAfterError = (
        closeErrorModal: () => void,
        onFormSubmitted: () => void,
        userAddress?: IUserAddress
    ) => {
        if (userAddress) {
            const postReplacementSimResult = postReplacementSim();

            if (postReplacementSimResult) {
                postReplacementSimResult.then((isSubmitted) => {
                    if (isSubmitted) {
                        closeErrorModal();
                        onFormSubmitted();
                    }
                });
            }
        }
    };

    return {
        barPreviousSim,
        setBarPreviousSim,
        postReplacementSimAfterError,
        postReplacementSimInitial,
        postReplacementSimState,
        formMethods,
    };
};
